/* Homenetics automatic Sale carousel */
(function(){
  if(document.getElementById('hn-sale-css')) return;
  var s=document.createElement('style');
  s.id='hn-sale-css';
  s.textContent='#hn-root .hn-sale-section{padding:64px 0 70px;background:linear-gradient(180deg,#fff 0%,#fff9f1 12%,#fff9f1 88%,#fff 100%)}#hn-root .hn-sale-section .hn-section-head{margin-bottom:28px}#hn-root .hn-sale-track{display:grid;grid-auto-flow:column;grid-auto-columns:calc((100% - 54px)/4);gap:18px;overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;scrollbar-width:none;padding:6px 4px 24px}#hn-root .hn-sale-track::-webkit-scrollbar{display:none}#hn-root .hn-sale-track .hn-product{scroll-snap-align:start;border-color:rgba(14,72,89,.12);box-shadow:none!important;overflow:hidden}#hn-root .hn-sale-track .hn-product:hover{box-shadow:none!important}#hn-root .hn-sale-track .hn-ph{height:310px!important;padding:18px;background:linear-gradient(145deg,#fafaf8,#f1f3f2);box-shadow:none!important}#hn-root .hn-sale-track .hn-ph img{width:100%;height:100%;object-fit:contain;object-position:center;mix-blend-mode:multiply}#hn-root .hn-sale-new{font-size:19px;font-weight:700;color:var(--red)}#hn-root .hn-sale-old{text-decoration:line-through;color:var(--muted);margin-left:7px}#hn-root .hn-sale-note{font-size:10.5px;color:var(--muted);margin-top:8px}#hn-root .hn-sale-nav{display:flex;gap:12px;align-items:center}#hn-root .hn-sale-arrows{display:flex;gap:3px;padding:4px;background:#fff;border:1px solid rgba(14,72,89,.13);border-radius:999px;box-shadow:none}#hn-root .hn-sale-arrows button{display:grid;place-items:center;width:38px;height:38px;padding:0;border:0;border-radius:50%;background:transparent;color:var(--teal);transition:background .2s,color .2s,transform .2s}#hn-root .hn-sale-arrows button:hover{background:var(--teal);color:#fff;transform:none}#hn-root .hn-sale-arrows svg{width:17px;height:17px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}#hn-root .hn-sale-skeleton{height:470px;border:1px solid rgba(14,72,89,.09);border-radius:14px;background:#fff;overflow:hidden}#hn-root .hn-sale-skeleton:before{content:"";display:block;height:310px;background:linear-gradient(100deg,#f4f4f1 30%,#fbfbf8 45%,#f4f4f1 60%);background-size:220% 100%;animation:hnSaleLoad 1.25s ease-in-out infinite}#hn-root .hn-sale-skeleton:after{content:"";display:block;width:72%;height:58px;margin:24px 18px;border-radius:8px;background:linear-gradient(100deg,#f1f1ee 30%,#fafaf7 45%,#f1f1ee 60%);background-size:220% 100%;animation:hnSaleLoad 1.25s ease-in-out infinite}@keyframes hnSaleLoad{to{background-position:-220% 0}}@media(max-width:960px){#hn-root .hn-sale-track{grid-auto-columns:calc((100% - 36px)/3)}#hn-root .hn-sale-track .hn-ph{height:290px!important}}@media(max-width:600px){#hn-root .hn-sale-section{padding:48px 0 54px}#hn-root .hn-sale-track{grid-auto-columns:84%;gap:14px}#hn-root .hn-sale-track .hn-ph{height:320px!important;padding:16px}#hn-root .hn-sale-arrows{display:none}#hn-root .hn-sale-nav{margin-left:auto}}';
  document.head.appendChild(s);
})();

(function(){
  function init(){
    var root=document.getElementById('hn-root'),hero=root&&root.querySelector('.hn-hero');
    if(!root||!hero){setTimeout(init,100);return}
    if(document.getElementById('hn-sale-section'))return;
    var box=document.createElement('section');
    box.id='hn-sale-section';box.className='hn-sale-section';
    box.innerHTML='<div class="hn-wrap"><div class="hn-section-head"><div><div class="hn-eyebrow">Limited-time offers</div><h2>Sale &mdash; up to 50% off</h2></div><div class="hn-sale-nav"><div class="hn-sale-arrows"><button type="button" data-d="-1" aria-label="Previous sale products"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg></button><button type="button" data-d="1" aria-label="Next sale products"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg></button></div><a class="hn-seeall" href="/collections/sale">View all deals &rarr;</a></div></div><div class="hn-sale-track" id="hn-sale-products"><div class="hn-sale-skeleton"></div><div class="hn-sale-skeleton"></div><div class="hn-sale-skeleton"></div><div class="hn-sale-skeleton"></div></div></div>';
    hero.insertAdjacentElement('afterend',box);
    var track=box.querySelector('#hn-sale-products');
    function esc(v){return String(v).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
    function disc(tags){tags=Array.isArray(tags)?tags.join(' '):(tags||'');return [50,35,30,20,15,10].find(function(n){return new RegExp('sale-'+n,'i').test(tags)})||0}
    function money(n){return Number(n).toLocaleString('en-US',{style:'currency',currency:'USD'})}
    fetch('/collections/sale/products.json?limit=12').then(function(r){if(!r.ok)throw Error(r.status);return r.json()}).then(function(data){
      var items=(data.products||[]).map(function(p){p._d=disc(p.tags);return p}).filter(function(p){return p._d&&p.variants&&p.variants.length});
      if(!items.length){box.remove();return}
      track.innerHTML=items.map(function(p,i){
        var prices=p.variants.map(function(v){return Number(v.price)}).filter(isFinite),base=Math.min.apply(Math,prices),now=base*(1-p._d/100),from=p.variants.length>1?'From ':'',img=p.images&&p.images[0]&&p.images[0].src||'',url='/products/'+encodeURIComponent(p.handle);
        return '<a class="hn-product" href="'+url+'"><div class="hn-product-badge-stack"><span class="hn-product-badge sale">'+p._d+'% off</span></div><div class="hn-ph has-img">'+(img?'<img loading="'+(i<4?'eager':'lazy')+'" src="'+esc(img)+'" alt="'+esc(p.title)+'">':'')+'</div><div class="hn-product-body"><div class="hn-product-cat">'+esc(p.product_type||p.vendor||'Homenetics')+'</div><div class="hn-product-name">'+esc(p.title)+'</div><div><span class="hn-sale-new">'+from+money(now)+'</span><span class="hn-sale-old">'+money(base)+'</span></div><div class="hn-sale-note">Discount applied automatically at checkout</div></div></a>';
      }).join('');
    }).catch(function(e){box.remove();console.warn('Sale collection could not load',e)});
    box.querySelectorAll('[data-d]').forEach(function(b){b.onclick=function(){track.scrollBy({left:Number(b.dataset.d)*track.clientWidth*.85,behavior:'smooth'})}});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* Homenetics product Sale price — synced with Shopify variants and Hulk Options */
(function () {
  'use strict';

  function getDiscountPercent() {
    var links = document.querySelectorAll('a[href*="/sale-"]');
    var found = 0;
    for (var i = 0; i < links.length; i++) {
      var href = (links[i].getAttribute('href') || '').toLowerCase();
      var match = href.match(/(?:^|\/|-)sale-(10|15|20|30|35|50)(?:\/|\?|#|$)/);
      if (match) found = Math.max(found, Number(match[1]));
    }
    return found;
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function initProductSalePrice() {
    if (!document.body || !document.body.classList.contains('template-product')) return;

    var percent = getDiscountPercent();
    if (!percent) return;

    if (!document.getElementById('hn-product-sale-price-css')) {
      var css = document.createElement('style');
      css.id = 'hn-product-sale-price-css';
      css.textContent =
        '.hn-product-sale-price{display:flex!important;align-items:baseline;gap:10px;flex-wrap:wrap}' +
        '.hn-product-sale-price .hn-sale-current{color:#d94b3d;font-weight:700;font-size:1.18em}' +
        '.hn-product-sale-price .hn-sale-original{color:#8b8b8b;font-size:.9em;text-decoration:line-through;text-decoration-thickness:1.5px}' +
        '.hn-product-sale-price .hn-sale-badge{display:inline-flex;align-items:center;background:#d94b3d;color:#fff;border-radius:999px;padding:4px 9px;font-size:11px;font-weight:700;line-height:1;letter-spacing:.02em}' +
        '.hn-product-sale-price .hn-sale-note{flex-basis:100%;color:#777;font-size:12px;line-height:1.35;margin-top:1px}' +
        '@media(max-width:767px){.hn-product-sale-price{gap:7px}.hn-product-sale-price .hn-sale-current{font-size:1.12em}.hn-product-sale-price .hn-sale-badge{padding:4px 7px;font-size:10px}}';
      document.head.appendChild(css);
    }

    var queued = false;

    function refresh() {
      queued = false;
      var price = document.querySelector(
        '.t4s-product__info-wrapper .t4s-product__price-review .t4s-product-price[data-product-price], ' +
        '.t4s-product__info-wrapper .t4s-product-price[data-product-price]'
      );
      if (!price) return;

      var original = Number(
        price.getAttribute('data-product-price') ||
        price.getAttribute('data-pr-price')
      );
      if (!Number.isFinite(original) || original <= 0) return;

      if (
        price.getAttribute('data-hn-sale-source') === String(original) &&
        price.querySelector('.hn-sale-current')
      ) return;

      var discounted = Math.round(original * (100 - percent) / 100);
      price.setAttribute('data-hn-sale-source', String(original));
      price.setAttribute('data-hn-sale-percent', String(percent));
      price.classList.add('hn-product-sale-price');
      price.innerHTML =
        '<span class="money hn-sale-current">' + formatMoney(discounted) + '</span>' +
        '<s class="money hn-sale-original">' + formatMoney(original) + '</s>' +
        '<span class="hn-sale-badge">' + percent + '% OFF</span>' +
        '<span class="hn-sale-note">Discount applied automatically at checkout</span>';
    }

    function scheduleRefresh() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(refresh);
    }

    var productInfo =
      document.querySelector('.t4s-product__info-wrapper') ||
      document.querySelector('[data-product-featured]') ||
      document.body;

    new MutationObserver(scheduleRefresh).observe(productInfo, {
      attributes: true,
      attributeFilter: ['data-product-price', 'data-pr-price'],
      childList: true,
      subtree: true
    });

    document.addEventListener('change', function (event) {
      if (
        event.target.closest('.t4s-product-form__variants') ||
        event.target.closest('.hulkapps_product_options')
      ) {
        scheduleRefresh();
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (event.target.closest('.hulkapps_product_options')) {
        scheduleRefresh();
      }
    }, true);

    ['variant:changed', 'variant:change', 'product:variant-change', 'hulkapps:price-change']
      .forEach(function (eventName) {
        document.addEventListener(eventName, scheduleRefresh);
      });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductSalePrice);
  } else {
    initProductSalePrice();
  }
})();

/* Homenetics cart Sale presentation â€” uses Shopify's final discounted values */
(function () {
  'use strict';

  function initCartSalePresentation() {
    if (!document.body || !document.body.classList.contains('template-cart')) return;

    if (!document.getElementById('hn-cart-sale-css')) {
      var style = document.createElement('style');
      style.id = 'hn-cart-sale-css';
      style.textContent =
        '.template-cart .hn-cart-sale-item{position:relative;background:linear-gradient(135deg,rgba(255,249,241,.72),rgba(255,255,255,0) 48%);border-color:rgba(217,75,61,.22)!important}' +
        '.template-cart .hn-cart-sale-item:before{content:"SALE";position:absolute;top:16px;left:16px;z-index:2;background:#d94b3d;color:#fff;border-radius:999px;padding:5px 10px;font-size:10px;font-weight:800;line-height:1;letter-spacing:.08em}' +
        '.template-cart .hn-cart-sale-item .t4s-cart_meta_prices:before{content:"SALE PRICE";display:block;color:#d94b3d;font-size:10px;font-weight:800;letter-spacing:.09em;margin-bottom:4px}' +
        '.template-cart .hn-cart-sale-item .t4s-cart_price,.template-cart .hn-cart-sale-item .t4s-cart-item-price{color:#d94b3d!important;font-size:18px!important;font-weight:800!important}' +
        '.template-cart .hn-cart-discount-detail{display:flex;align-items:center;justify-content:center;gap:7px;flex-wrap:wrap;margin-top:8px}' +
        '.template-cart .hn-cart-discount-percent{display:inline-flex;align-items:center;background:#d94b3d;color:#fff;border-radius:999px;padding:5px 9px;font-size:10px;font-weight:800;letter-spacing:.04em}' +
        '.template-cart .hn-cart-discount-saving{color:#d94b3d;font-size:12px;font-weight:700}' +
        '.template-cart .hn-cart-was{display:block;color:#8b8b8b;font-size:12px;text-decoration:line-through;text-decoration-thickness:1.5px;margin-bottom:3px}' +
        '.template-cart .t4s-cart-total{position:relative;border:1px solid rgba(217,75,61,.18);border-radius:14px;padding:18px!important;background:linear-gradient(145deg,#fff 48%,#fff8f3 100%)}' +
        '.template-cart .hn-cart-sale-banner{display:flex;align-items:center;gap:11px;padding:12px 13px;margin:0 0 17px;background:#fff3ec;border:1px solid rgba(217,75,61,.2);border-radius:10px;color:#193f4c}' +
        '.template-cart .hn-cart-sale-icon{display:grid;place-items:center;flex:0 0 34px;height:34px;border-radius:50%;background:#d94b3d;color:#fff;font-size:16px}' +
        '.template-cart .hn-cart-sale-banner strong{display:block;color:#d94b3d;font-size:12px;line-height:1.2;letter-spacing:.06em}' +
        '.template-cart .hn-cart-sale-banner span{display:block;color:#68777c;font-size:11px;line-height:1.35;margin-top:2px}' +
        '.template-cart .t4s-cart__originalPrice{color:#8a8a8a!important;font-size:14px!important;text-decoration:line-through;text-decoration-thickness:1.5px}' +
        '.template-cart .t4s-cart__discountPrice{display:inline-block!important;background:#d94b3d;color:#fff!important;border-radius:999px;padding:6px 10px;margin:7px 0;font-size:12px!important;font-weight:800!important}' +
        '.template-cart .t4s-cart__totalPrice{color:#173f4d!important;font-size:27px!important;font-weight:800!important;line-height:1.15}' +
        '@media(max-width:767px){.template-cart .hn-cart-sale-item:before{top:10px;left:10px}.template-cart .hn-cart-discount-detail{justify-content:flex-start}.template-cart .t4s-cart-total{padding:15px!important}.template-cart .t4s-cart__totalPrice{font-size:24px!important}}';
      document.head.appendChild(style);
    }

    var busy = false;

    function parseMoney(value) {
      var number = Number(String(value || '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(number) ? Math.abs(number) : 0;
    }

    function formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(value);
    }

    function refreshCartSale() {
      busy = false;

      document.querySelectorAll('.t4s-page_cart__item').forEach(function (item) {
        var discountItem = item.querySelector('.t4s-order-discount__item');
        if (!discountItem) return;

        var raw = (discountItem.textContent || '').replace(/\s+/g, ' ').trim();
        var match = raw.match(/sale\s+(10|15|20|30|35|50)%.*?\(-?\$?([\d,.]+)\)/i);
        if (!match) return;

        item.classList.add('hn-cart-sale-item');

        var detail = item.querySelector('.hn-cart-discount-detail');
        if (!detail) {
          detail = document.createElement('div');
          detail.className = 'hn-cart-discount-detail';
          discountItem.insertAdjacentElement('afterend', detail);
        }
        var detailMarkup =
          '<span class="hn-cart-discount-percent">' + match[1] + '% OFF</span>' +
          '<span class="hn-cart-discount-saving">You save ' + formatMoney(parseMoney(match[2])) + '</span>';
        if (detail.innerHTML !== detailMarkup) detail.innerHTML = detailMarkup;

        var lineTotal = item.querySelector('.t4s-cart-item-price');
        if (lineTotal) {
          var current = parseMoney(lineTotal.textContent);
          var saved = parseMoney(match[2]);
          var was = item.querySelector('.hn-cart-was');
          if (!was) {
            was = document.createElement('span');
            was.className = 'hn-cart-was';
            lineTotal.insertAdjacentElement('beforebegin', was);
          }
          var wasText = 'Was ' + formatMoney(current + saved);
          if (was.textContent !== wasText) was.textContent = wasText;
        }
      });

      var summary = document.querySelector('.t4s-cart-total');
      var summaryDiscount = document.querySelector('.t4s-cart__discountPrice');
      if (summary && summaryDiscount) {
        var savedAmount = parseMoney(summaryDiscount.textContent);
        var savedLabel = 'YOU SAVE ' + formatMoney(savedAmount);
        if (summaryDiscount.textContent !== savedLabel) summaryDiscount.textContent = savedLabel;

        var banner = summary.querySelector('.hn-cart-sale-banner');
        if (!banner) {
          banner = document.createElement('div');
          banner.className = 'hn-cart-sale-banner';
          banner.innerHTML =
            '<div class="hn-cart-sale-icon">%</div>' +
            '<div><strong>SALE DISCOUNT APPLIED</strong><span>Your discounted price is active and will carry through checkout.</span></div>';
          summary.insertAdjacentElement('afterbegin', banner);
        }
      }
    }

    function scheduleRefresh() {
      if (busy) return;
      busy = true;
      setTimeout(refreshCartSale, 80);
    }

    var cartRoot = document.querySelector('.t4s-main-cart') || document.body;
    new MutationObserver(scheduleRefresh).observe(cartRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('change', scheduleRefresh, true);
    refreshCartSale();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartSalePresentation);
  } else {
    initCartSalePresentation();
  }
})();
/* Homenetics enhanced mini cart */
(function () {
  'use strict';

  function initHnMiniCart() {
    var drawer = document.getElementById('t4s-mini_cart');
    if (!drawer) return;

    if (!document.getElementById('hn-mini-cart-css')) {
      var css = document.createElement('style');
      css.id = 'hn-mini-cart-css';
      css.textContent =
        '#t4s-mini_cart.hn-mini-open{display:flex!important;visibility:visible!important;opacity:1!important;transform:translate3d(0,0,0)!important;z-index:100002!important;width:460px;max-width:94vw}' +
        '.hn-mini-overlay{position:fixed;inset:0;background:rgba(13,31,38,.55);backdrop-filter:blur(1px);z-index:100001;opacity:0;transition:opacity .22s ease}' +
        '.hn-mini-overlay.is-visible{opacity:1}.hn-mini-lock{overflow:hidden!important}' +
        '#t4s-mini_cart .t4s-drawer__header{border-bottom:1px solid #e8ecee;padding:17px 20px}' +
        '#t4s-mini_cart .t4s-drawer__header span{font-weight:800;letter-spacing:.03em;color:#153f4c}' +
        '#t4s-mini_cart .t4s-mini_cart__item{align-items:flex-start!important;padding:18px 16px!important;border-bottom:1px solid #edf0f1}' +
        '#t4s-mini_cart .t4s-mini_cart__img{width:92px!important;min-width:92px!important;height:118px!important;background:#f7f8f7!important;border-radius:8px}' +
        '#t4s-mini_cart .t4s-mini_cart__img img{object-fit:contain!important}' +
        '#t4s-mini_cart .t4s-mini_cart__info{min-width:0;flex:1;padding-left:14px!important}' +
        '#t4s-mini_cart .t4s-mini_cart__title{white-space:normal!important;display:-webkit-box!important;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-weight:700;line-height:1.35;color:#153f4c}' +
        '#t4s-mini_cart .t4s-cart_meta_variant{font-size:12px;color:#778287;margin:5px 0 8px}' +
        '#t4s-mini_cart .hn-mini-properties .t4s-product-details__item{font-size:11px;line-height:1.4;margin:2px 0;color:#69777c}' +
        '#t4s-mini_cart .hn-mini-properties:not(.is-expanded) .t4s-product-details__item:nth-child(n+4){display:none!important}' +
        '#t4s-mini_cart .hn-mini-details{border:0;background:transparent;color:#0e596c;text-decoration:underline;padding:3px 0 5px;font-size:11px;font-weight:700;cursor:pointer}' +
        '#t4s-mini_cart .hn-mini-sale-prices{display:flex;align-items:baseline;gap:7px;flex-wrap:wrap;margin:8px 0 5px}' +
        '#t4s-mini_cart .hn-mini-current{color:#d94b3d;font-size:17px;font-weight:800}' +
        '#t4s-mini_cart .hn-mini-original{color:#92999c;font-size:12px;text-decoration:line-through;text-decoration-thickness:1.5px}' +
        '#t4s-mini_cart .hn-mini-badge{background:#d94b3d;color:#fff;border-radius:999px;padding:4px 7px;font-size:9px;font-weight:800}' +
        '#t4s-mini_cart .hn-mini-saving{flex-basis:100%;color:#d94b3d;font-size:11px;font-weight:700}' +
        '#t4s-mini_cart .hn-has-sale>.t4s-cart_price{display:none!important}' +
        '#t4s-mini_cart .hn-mini-sale-summary{margin:0 0 12px;padding:13px 14px;border:1px solid rgba(217,75,61,.2);border-radius:10px;background:#fff5ef}' +
        '#t4s-mini_cart .hn-mini-summary-row{display:flex;justify-content:space-between;align-items:center;margin:4px 0;font-size:12px;color:#68777c}' +
        '#t4s-mini_cart .hn-mini-summary-row.original span:last-child{text-decoration:line-through}' +
        '#t4s-mini_cart .hn-mini-summary-row.saving{color:#d94b3d;font-weight:800}' +
        '#t4s-mini_cart .hn-mini-summary-row.total{padding-top:7px;margin-top:7px;border-top:1px solid rgba(217,75,61,.16);color:#153f4c;font-size:17px;font-weight:800}' +
        '#t4s-mini_cart .t4s-cart-total{padding-top:10px!important}' +
        '#t4s-mini_cart .t4s-btn__cart,#t4s-mini_cart .t4s-btn__checkout{min-height:46px!important;border-radius:7px!important;font-weight:800!important}' +
        '#t4s-mini_cart .t4s-btn__checkout{background:#ff9f22!important;color:#fff!important}' +
        '#t4s-mini_cart .t4s-cat__imgtrust{display:flex!important;justify-content:center!important;align-items:center!important;gap:8px!important;flex-wrap:wrap!important;padding:12px 0!important}' +
        '#t4s-mini_cart .t4s-cat__imgtrust img:not([alt="shopify pay"]):not([alt="visa"]):not([alt="master"]):not([alt="apple pay"]){display:none!important}' +
        '#t4s-mini_cart .t4s-cat__imgtrust img{height:30px!important;width:auto!important;margin:0!important}' +
        '@media(max-width:520px){#t4s-mini_cart.hn-mini-open{width:92vw}.hn-mini-overlay{backdrop-filter:none}#t4s-mini_cart .t4s-mini_cart__item{padding:14px 12px!important}#t4s-mini_cart .t4s-mini_cart__img{width:78px!important;min-width:78px!important;height:104px!important}}';
      document.head.appendChild(css);
    }

    function money(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format((Number(cents) || 0) / 100);
    }

    function closeMini() {
      drawer.classList.remove('hn-mini-open');
      drawer.classList.add('t4s-dn');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('hn-mini-lock');
      document.body.classList.remove('hn-mini-lock');
      var overlay = document.querySelector('.hn-mini-overlay');
      if (overlay) overlay.remove();
    }

    function openMini() {
      var overlay = document.querySelector('.hn-mini-overlay');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'hn-mini-overlay';
        document.body.appendChild(overlay);
        overlay.addEventListener('click', closeMini);
      }
      drawer.classList.remove('t4s-dn');
      drawer.classList.add('hn-mini-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('hn-mini-lock');
      document.body.classList.add('hn-mini-lock');
      requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
      scheduleRefresh();
    }

    document.addEventListener('click', function (event) {
      var headerCart = event.target.closest('.hnh-ic[aria-label="Cart"]');
      if (headerCart) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openMini();
        return;
      }
      var details = event.target.closest('.hn-mini-details');
      if (details) {
        event.preventDefault();
        var list = details.previousElementSibling;
        var expanded = list.classList.toggle('is-expanded');
        details.textContent = expanded ? 'Hide details' : details.dataset.label;
      }
      if (event.target.closest('#t4s-mini_cart .t4s-drawer__close')) closeMini();
    }, true);

    var queued = false;
    function scheduleRefresh() {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; refreshMini(); }, 180);
    }

    async function refreshMini() {
      var response;
      try { response = await fetch('/cart.js', { credentials: 'same-origin' }); } catch (error) { return; }
      if (!response.ok) return;
      var cart = await response.json();

      drawer.querySelectorAll('.t4s-mini_cart__item').forEach(function (element) {
        var remove = element.querySelector('[data-cart-remove][data-id]');
        var key = remove && remove.getAttribute('data-id');
        var item = cart.items.find(function (entry) { return entry.key === key; });
        if (!item) return;

        var properties = element.querySelector('.t4s-cart_meta_propertyList');
        if (properties && properties.children.length > 3) {
          properties.classList.add('hn-mini-properties');
          var button = element.querySelector('.hn-mini-details');
          if (!button) {
            button = document.createElement('button');
            button.type = 'button';
            button.className = 'hn-mini-details';
            button.dataset.label = 'View all ' + properties.children.length + ' options';
            button.textContent = button.dataset.label;
            properties.insertAdjacentElement('afterend', button);
          }
        }

        var priceBox = element.querySelector('.t4s-cart_meta_price');
        if (!priceBox) return;
        var original = Number(item.original_line_price || item.line_price || 0);
        var finalPrice = Number(item.final_line_price || item.line_price || 0);
        var saving = Math.max(0, original - finalPrice);
        var existing = priceBox.querySelector('.hn-mini-sale-prices');
        if (saving > 0) {
          priceBox.classList.add('hn-has-sale');
          var percent = Math.round((saving / original) * 100);
          var markup = '<div class="hn-mini-sale-prices"><span class="hn-mini-current">' + money(finalPrice) + '</span><span class="hn-mini-original">' + money(original) + '</span><span class="hn-mini-badge">' + percent + '% OFF</span><span class="hn-mini-saving">You save ' + money(saving) + '</span></div>';
          if (!existing || existing.outerHTML !== markup) {
            if (existing) existing.remove();
            priceBox.insertAdjacentHTML('beforeend', markup);
          }
        } else {
          priceBox.classList.remove('hn-has-sale');
          if (existing) existing.remove();
        }
      });

      var footer = drawer.querySelector('.t4s-drawer__bottom, .t4s-drawer__footer, .t4s-mini_cart__footer') || drawer.querySelector('.t4s-cart-total')?.parentElement;
      var totalRow = drawer.querySelector('.t4s-cart-total');
      var summary = drawer.querySelector('.hn-mini-sale-summary');
      var cartSaving = Math.max(0, Number(cart.original_total_price || cart.total_price) - Number(cart.total_price));
      if (footer && totalRow && cartSaving > 0) {
        var summaryMarkup = '<div class="hn-mini-sale-summary"><div class="hn-mini-summary-row original"><span>Original subtotal</span><span>' + money(cart.original_total_price) + '</span></div><div class="hn-mini-summary-row saving"><span>You save</span><span>-' + money(cartSaving) + '</span></div><div class="hn-mini-summary-row total"><span>Sale total</span><span>' + money(cart.total_price) + '</span></div></div>';
        if (!summary || summary.outerHTML !== summaryMarkup) {
          if (summary) summary.remove();
          totalRow.insertAdjacentHTML('beforebegin', summaryMarkup);
        }
      } else if (summary) {
        summary.remove();
      }
      var totalPrice = drawer.querySelector('.t4s-cart__totalPrice');
      if (totalPrice) totalPrice.textContent = money(cart.total_price);
    }

    new MutationObserver(scheduleRefresh).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('change', scheduleRefresh, true);
    refreshMini();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHnMiniCart);
  else initHnMiniCart();
})();


/* HN_SMART_MINI_RECOMMENDATIONS_V1 */
(function () {
  var STYLE_ID = 'hn-smart-mini-recs-css';
  var MAX_RECS = 6;
  var scheduled = 0;
  var lastSignature = '';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #t4s-mini_cart .t4s-minicart-recommendations { display: none !important; }
      #t4s-mini_cart .hn-smart-recs {
        margin: 16px 16px 4px;
        padding: 0;
        border: 1px solid #dfe7e9;
        border-radius: 14px;
        background: #fff;
        box-shadow: 0 6px 22px rgba(6,58,72,.07);
        overflow: hidden;
        color: #123f4a;
      }
      #t4s-mini_cart .hn-smart-recs__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        padding: 14px 14px 11px;
        border-bottom: 1px solid #edf1f2;
      }
      #t4s-mini_cart .hn-smart-recs__eyebrow {
        margin: 0 0 2px;
        color: #ef9216;
        font-size: 10px;
        line-height: 1;
        font-weight: 800;
        letter-spacing: .12em;
        text-transform: uppercase;
      }
      #t4s-mini_cart .hn-smart-recs__title {
        margin: 0;
        color: #123f4a;
        font-size: 16px;
        line-height: 1.2;
        font-weight: 800;
      }
      #t4s-mini_cart .hn-smart-recs__nav {
        display: flex;
        gap: 6px;
        flex: 0 0 auto;
      }
      #t4s-mini_cart .hn-smart-recs__nav button {
        width: 32px;
        height: 32px;
        padding: 0;
        border: 1px solid #cad8dc;
        border-radius: 50%;
        background: #fff;
        color: #0d5668;
        font-size: 18px;
        line-height: 1;
        cursor: pointer;
        transition: .18s ease;
      }
      #t4s-mini_cart .hn-smart-recs__nav button:hover {
        border-color: #0d5668;
        background: #f3f8f9;
        transform: translateY(-1px);
      }
      #t4s-mini_cart .hn-smart-recs__track {
        display: grid;
        grid-auto-flow: column;
        grid-auto-columns: minmax(164px, 48%);
        gap: 10px;
        padding: 12px 14px 14px;
        overflow-x: auto;
        overscroll-behavior-inline: contain;
        scroll-snap-type: x mandatory;
        scrollbar-width: none;
      }
      #t4s-mini_cart .hn-smart-recs__track::-webkit-scrollbar { display: none; }
      #t4s-mini_cart .hn-smart-rec {
        min-width: 0;
        overflow: hidden;
        border: 1px solid #e5ebed;
        border-radius: 11px;
        background: #fff;
        scroll-snap-align: start;
        transition: border-color .18s ease, transform .18s ease, box-shadow .18s ease;
      }
      #t4s-mini_cart .hn-smart-rec:hover {
        border-color: #b9ced3;
        transform: translateY(-2px);
        box-shadow: 0 7px 18px rgba(6,58,72,.09);
      }
      #t4s-mini_cart .hn-smart-rec__image {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 132px;
        padding: 8px;
        background: #f7f8f8;
        overflow: hidden;
      }
      #t4s-mini_cart .hn-smart-rec__image img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: contain;
        transition: transform .22s ease;
      }
      #t4s-mini_cart .hn-smart-rec:hover .hn-smart-rec__image img { transform: scale(1.025); }
      #t4s-mini_cart .hn-smart-rec__body { padding: 10px 10px 12px; }
      #t4s-mini_cart .hn-smart-rec__vendor {
        margin-bottom: 4px;
        color: #ef9216;
        font-size: 9px;
        line-height: 1.1;
        font-weight: 800;
        letter-spacing: .08em;
        text-transform: uppercase;
      }
      #t4s-mini_cart .hn-smart-rec__name {
        display: -webkit-box;
        min-height: 35px;
        margin: 0;
        overflow: hidden;
        color: #174c59;
        font-size: 12px;
        line-height: 1.42;
        font-weight: 700;
        text-decoration: none;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
      #t4s-mini_cart .hn-smart-rec__price {
        margin-top: 7px;
        color: #d84c3d;
        font-size: 14px;
        line-height: 1.2;
        font-weight: 800;
      }
      #t4s-mini_cart .hn-smart-recs__reason {
        padding: 0 14px 13px;
        color: #71848a;
        font-size: 10px;
        line-height: 1.35;
      }
      @media (max-width: 480px) {
        #t4s-mini_cart .hn-smart-recs { margin-inline: 12px; }
        #t4s-mini_cart .hn-smart-recs__track { grid-auto-columns: minmax(155px, 66%); }
        #t4s-mini_cart .hn-smart-rec__image { height: 122px; }
      }
    `;
    document.head.appendChild(style);
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[char];
    });
  }

  function money(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
      maximumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function shorterTitle(title) {
    var parts = String(title || '').split('|').map(function (part) { return part.trim(); }).filter(Boolean);
    return parts.slice(0, 2).join(' | ') || title || 'Recommended product';
  }

  function productImage(product) {
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product.images && product.images[0]) {
      return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    }
    return '';
  }

  function render(drawer, products, signature) {
    var legacy = drawer.querySelector('.t4s-minicart-recommendations');
    if (!legacy || !products.length) return;
    var old = drawer.querySelector('.hn-smart-recs');
    if (old && old.dataset.signature === signature) return;

    var cards = products.map(function (product) {
      var url = product.url || ('/products/' + product.handle);
      var image = productImage(product);
      var vendor = product.vendor || product.product_type || 'Recommended';
      return '<article class="hn-smart-rec">' +
        '<a class="hn-smart-rec__image" href="' + esc(url) + '">' +
          (image ? '<img src="' + esc(image) + '&width=360" alt="' + esc(product.title) + '" loading="lazy" width="220" height="220">' : '') +
        '</a>' +
        '<div class="hn-smart-rec__body">' +
          '<div class="hn-smart-rec__vendor">' + esc(vendor) + '</div>' +
          '<a class="hn-smart-rec__name" href="' + esc(url) + '">' + esc(shorterTitle(product.title)) + '</a>' +
          '<div class="hn-smart-rec__price">From ' + money(product.price) + '</div>' +
        '</div>' +
      '</article>';
    }).join('');

    var section = document.createElement('section');
    section.className = 'hn-smart-recs';
    section.dataset.signature = signature;
    section.setAttribute('aria-label', 'Recommended products');
    section.innerHTML =
      '<div class="hn-smart-recs__head">' +
        '<div><div class="hn-smart-recs__eyebrow">Selected for you</div><h3 class="hn-smart-recs__title">Pairs well with your cart</h3></div>' +
        '<div class="hn-smart-recs__nav"><button type="button" class="hn-smart-recs__prev" aria-label="Previous recommendations">‹</button><button type="button" class="hn-smart-recs__next" aria-label="Next recommendations">›</button></div>' +
      '</div>' +
      '<div class="hn-smart-recs__track">' + cards + '</div>' +
      '<div class="hn-smart-recs__reason">Related products selected automatically from the items in your cart.</div>';

    if (old) old.replaceWith(section);
    else legacy.insertAdjacentElement('beforebegin', section);

    var track = section.querySelector('.hn-smart-recs__track');
    section.querySelector('.hn-smart-recs__prev').addEventListener('click', function () {
      track.scrollBy({ left: -Math.max(180, track.clientWidth * .72), behavior: 'smooth' });
    });
    section.querySelector('.hn-smart-recs__next').addEventListener('click', function () {
      track.scrollBy({ left: Math.max(180, track.clientWidth * .72), behavior: 'smooth' });
    });
  }

  async function buildRecommendations() {
    scheduled = 0;
    var drawer = document.querySelector('#t4s-mini_cart');
    if (!drawer || !drawer.querySelector('.t4s-minicart-recommendations')) return;
    try {
      var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) { return response.json(); });
      var ids = Array.from(new Set((cart.items || []).map(function (item) { return item.product_id; }).filter(Boolean)));
      if (!ids.length) return;
      var signature = ids.slice().sort().join('-');
      if (signature === lastSignature && drawer.querySelector('.hn-smart-recs')) return;

      var groups = await Promise.all(ids.slice(0, 4).map(function (id) {
        return fetch('/recommendations/products.json?product_id=' + encodeURIComponent(id) + '&limit=4&intent=related', { credentials: 'same-origin' })
          .then(function (response) { return response.ok ? response.json() : { products: [] }; })
          .then(function (data) { return data.products || []; })
          .catch(function () { return []; });
      }));

      var cartIds = new Set(ids.map(String));
      var seen = new Set();
      var combined = [];
      var longest = Math.max.apply(Math, groups.map(function (group) { return group.length; }).concat([0]));
      for (var row = 0; row < longest && combined.length < MAX_RECS; row++) {
        groups.forEach(function (group) {
          var product = group[row];
          if (!product || combined.length >= MAX_RECS) return;
          var id = String(product.id);
          if (cartIds.has(id) || seen.has(id)) return;
          seen.add(id);
          combined.push(product);
        });
      }
      if (combined.length) {
        render(drawer, combined, signature);
        lastSignature = signature;
      }
    } catch (error) {
      console.warn('Mini cart recommendations:', error);
    }
  }

  function schedule() {
    clearTimeout(scheduled);
    scheduled = setTimeout(buildRecommendations, 350);
  }

  function init() {
    addStyles();
    schedule();
    var drawer = document.querySelector('#t4s-mini_cart');
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    document.addEventListener('change', schedule, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* HN_THREE_VERTICAL_HERO_BANNERS_V1 */
(function () {
  var STYLE_ID = 'hn-three-banners-css';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #hn-root .hn-hero-grid.hn-three-banner-layout {
        grid-template-columns: 280px minmax(0, 1fr) !important;
        align-items: stretch !important;
        gap: 16px !important;
      }
      #hn-root .hn-three-banner-layout > .hn-slider,
      #hn-root .hn-three-banner-layout > div:has(> .hn-slider),
      #hn-root .hn-three-banner-layout > .hn-promo-stack {
        display: none !important;
      }
      #hn-root .hn-banner-grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 14px;
        min-width: 0;
        height: 620px;
      }
      #hn-root .hn-vertical-banner {
        position: relative;
        display: block;
        min-width: 0;
        height: 100%;
        overflow: hidden;
        border: 1px solid rgba(9,63,77,.16);
        border-radius: 18px;
        background: #0b3f4b;
        box-shadow: 0 8px 24px rgba(8,52,63,.09);
        color: #fff;
        isolation: isolate;
        text-decoration: none;
      }
      #hn-root .hn-vertical-banner__image {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: transform .65s cubic-bezier(.2,.7,.2,1);
        z-index: -3;
      }
      #hn-root .hn-vertical-banner::before {
        content: '';
        position: absolute;
        inset: 0;
        background:
          linear-gradient(180deg, rgba(0,24,31,.08) 0%, rgba(0,24,31,.02) 32%, rgba(0,24,31,.82) 78%, rgba(0,24,31,.96) 100%);
        z-index: -2;
      }
      #hn-root .hn-vertical-banner::after {
        content: '';
        position: absolute;
        inset: 0;
        border: 1px solid rgba(255,255,255,.16);
        border-radius: inherit;
        pointer-events: none;
        z-index: 3;
      }
      #hn-root .hn-vertical-banner:hover .hn-vertical-banner__image {
        transform: scale(1.055);
      }
      #hn-root .hn-vertical-banner__top {
        position: absolute;
        top: 18px;
        left: 18px;
        right: 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 10px;
      }
      #hn-root .hn-vertical-banner__tag {
        display: inline-flex;
        align-items: center;
        min-height: 28px;
        padding: 7px 11px;
        border: 1px solid rgba(255,255,255,.34);
        border-radius: 999px;
        background: rgba(7,47,57,.58);
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);
        color: #fff;
        font-size: 10px;
        line-height: 1;
        font-weight: 800;
        letter-spacing: .1em;
        text-transform: uppercase;
      }
      #hn-root .hn-vertical-banner__arrow {
        display: grid;
        place-items: center;
        width: 34px;
        height: 34px;
        flex: 0 0 auto;
        border-radius: 50%;
        background: rgba(255,255,255,.92);
        color: #0b4f5f;
        transition: transform .22s ease, background .22s ease;
      }
      #hn-root .hn-vertical-banner:hover .hn-vertical-banner__arrow {
        transform: translateX(3px);
        background: #fff;
      }
      #hn-root .hn-vertical-banner__content {
        position: absolute;
        left: 22px;
        right: 22px;
        bottom: 22px;
      }
      #hn-root .hn-vertical-banner__eyebrow {
        margin-bottom: 8px;
        color: #ff9f1a;
        font-size: 10px;
        line-height: 1;
        font-weight: 900;
        letter-spacing: .14em;
        text-transform: uppercase;
      }
      #hn-root .hn-vertical-banner__title {
        margin: 0 0 8px;
        color: #fff;
        font-size: clamp(22px, 2vw, 29px);
        line-height: 1.04;
        font-weight: 850;
        letter-spacing: -.025em;
        text-wrap: balance;
      }
      #hn-root .hn-vertical-banner__copy {
        max-width: 26ch;
        margin: 0 0 16px;
        color: rgba(255,255,255,.84);
        font-size: 12px;
        line-height: 1.48;
      }
      #hn-root .hn-vertical-banner__cta {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        min-height: 38px;
        padding: 10px 15px;
        border-radius: 999px;
        background: #fff;
        color: #0b4f5f;
        font-size: 11px;
        line-height: 1;
        font-weight: 850;
        box-shadow: 0 5px 15px rgba(0,0,0,.13);
      }
      #hn-root .hn-vertical-banner--feature .hn-vertical-banner__cta {
        background: #ff9f1a;
        color: #102f37;
      }
      @media (max-width: 1180px) {
        #hn-root .hn-hero-grid.hn-three-banner-layout {
          grid-template-columns: 250px minmax(0, 1fr) !important;
        }
        #hn-root .hn-banner-grid { height: 560px; gap: 11px; }
        #hn-root .hn-vertical-banner__content { left: 17px; right: 17px; bottom: 18px; }
        #hn-root .hn-vertical-banner__title { font-size: 22px; }
      }
      @media (max-width: 767px) {
        #hn-root .hn-hero { overflow: hidden; }
        #hn-root .hn-hero-grid.hn-three-banner-layout {
          display: block !important;
        }
        #hn-root .hn-three-banner-layout > .hn-sidebar {
          display: none !important;
        }
        #hn-root .hn-banner-grid {
          display: grid;
          grid-auto-flow: column;
          grid-template-columns: none;
          grid-auto-columns: min(82vw, 330px);
          gap: 12px;
          width: auto;
          height: auto;
          margin: 12px -16px 0;
          padding: 0 16px 10px;
          overflow-x: auto;
          overscroll-behavior-inline: contain;
          scroll-snap-type: x mandatory;
          scrollbar-width: none;
        }
        #hn-root .hn-banner-grid::-webkit-scrollbar { display: none; }
        #hn-root .hn-vertical-banner {
          width: 100%;
          height: auto;
          aspect-ratio: 9 / 14;
          min-height: 430px;
          max-height: 520px;
          scroll-snap-align: start;
          border-radius: 16px;
        }
        #hn-root .hn-vertical-banner__top { top: 15px; left: 15px; right: 15px; }
        #hn-root .hn-vertical-banner__content { left: 18px; right: 18px; bottom: 19px; }
        #hn-root .hn-vertical-banner__title { font-size: 25px; }
        #hn-root .hn-vertical-banner__copy { font-size: 12px; }
      }
    `;
    document.head.appendChild(style);
  }

  function banner(data, featured) {
    return '<a class="hn-vertical-banner' + (featured ? ' hn-vertical-banner--feature' : '') + '" href="' + data.href + '">' +
      '<img class="hn-vertical-banner__image" src="' + data.image + '" alt="' + data.alt + '" loading="' + (featured ? 'eager' : 'lazy') + '">' +
      '<div class="hn-vertical-banner__top">' +
        '<span class="hn-vertical-banner__tag">' + data.tag + '</span>' +
        '<span class="hn-vertical-banner__arrow" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M5 12h14M13 5l7 7-7 7"></path></svg></span>' +
      '</div>' +
      '<div class="hn-vertical-banner__content">' +
        '<div class="hn-vertical-banner__eyebrow">' + data.eyebrow + '</div>' +
        '<h2 class="hn-vertical-banner__title">' + data.title + '</h2>' +
        '<p class="hn-vertical-banner__copy">' + data.copy + '</p>' +
        '<span class="hn-vertical-banner__cta">' + data.cta + '<span aria-hidden="true">→</span></span>' +
      '</div>' +
    '</a>';
  }

  function initThreeBanners() {
    addStyles();
    var grid = document.querySelector('#hn-root .hn-hero-grid');
    if (!grid || grid.querySelector('.hn-banner-grid')) return;
    grid.classList.add('hn-three-banner-layout');

    var oldSliderWrap = grid.querySelector('.hn-slider') && grid.querySelector('.hn-slider').parentElement;
    var oldPromo = grid.querySelector('.hn-promo-stack');
    var data = [
      {
        href: '/collections/interior-doors',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/10-interior-door.jpg?v=1776788264',
        alt: 'Modern interior doors',
        tag: '410+ styles',
        eyebrow: 'Interior doors',
        title: 'Designed for every room.',
        copy: 'French, pocket, barn, bi-fold and hidden door systems.',
        cta: 'Explore interior'
      },
      {
        href: '/collections/exterior-door',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/12-wrough-001-door.jpg?v=1776788264',
        alt: 'Premium exterior doors',
        tag: 'Built to impress',
        eyebrow: 'Exterior doors',
        title: 'Make the entrance unforgettable.',
        copy: 'Wrought iron, steel and aluminum doors built for lasting curb appeal.',
        cta: 'Explore exterior'
      },
      {
        href: '/collections/metal-awnings',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/11-metal-awning.jpg?v=1776788264',
        alt: 'Architectural metal awnings',
        tag: 'Made for NJ',
        eyebrow: 'Awnings & outdoor',
        title: 'Shade with architectural style.',
        copy: 'Durable metal awnings and outdoor solutions for year-round protection.',
        cta: 'Explore awnings'
      }
    ];

    var banners = document.createElement('div');
    banners.className = 'hn-banner-grid';
    banners.setAttribute('aria-label', 'Featured product categories');
    banners.innerHTML = data.map(function (item, index) { return banner(item, index === 0); }).join('');

    if (oldSliderWrap) oldSliderWrap.replaceWith(banners);
    else grid.appendChild(banners);
    if (oldPromo) oldPromo.remove();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initThreeBanners);
  else initThreeBanners();
})();


/* HN_FULL_WIDTH_HERO_CAROUSEL_V2 */
(function () {
  var STYLE_ID = 'hn-full-hero-carousel-css';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #hn-root .hn-banner-grid.hn-full-carousel {
        position: relative;
        display: block !important;
        width: 100%;
        height: 620px;
        min-width: 0;
        overflow: hidden !important;
        border-radius: 18px;
        margin: 0 !important;
        padding: 0 !important;
        touch-action: pan-y;
      }
      #hn-root .hn-full-carousel__track {
        display: flex;
        width: 100%;
        height: 100%;
        transition: transform .65s cubic-bezier(.22,.75,.2,1);
        will-change: transform;
      }
      #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner {
        flex: 0 0 100%;
        width: 100%;
        min-width: 100%;
        height: 100%;
        aspect-ratio: auto;
        border-radius: 18px;
        scroll-snap-align: none;
      }
      #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__image {
        object-position: center;
      }
      #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__title {
        max-width: 620px;
        font-size: clamp(34px, 4vw, 56px);
        line-height: .99;
      }
      #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__copy {
        max-width: 52ch;
        font-size: 14px;
      }
      #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__content {
        left: 34px;
        right: 34px;
        bottom: 32px;
      }
      #hn-root .hn-full-carousel__arrow {
        position: absolute;
        top: 50%;
        z-index: 8;
        display: grid;
        place-items: center;
        width: 46px;
        height: 46px;
        padding: 0;
        border: 1px solid rgba(11,79,95,.14);
        border-radius: 50%;
        background: rgba(255,255,255,.94);
        color: #0b4f5f;
        box-shadow: 0 8px 22px rgba(0,0,0,.13);
        cursor: pointer;
        transform: translateY(-50%);
        transition: transform .2s ease, background .2s ease;
      }
      #hn-root .hn-full-carousel__arrow:hover {
        background: #fff;
        transform: translateY(-50%) scale(1.06);
      }
      #hn-root .hn-full-carousel__arrow.prev { left: 18px; }
      #hn-root .hn-full-carousel__arrow.next { right: 18px; }
      #hn-root .hn-full-carousel__dots {
        position: absolute;
        top: 23px;
        left: 50%;
        z-index: 8;
        display: flex;
        gap: 7px;
        padding: 7px 9px;
        border-radius: 999px;
        background: rgba(7,47,57,.45);
        -webkit-backdrop-filter: blur(8px);
        backdrop-filter: blur(8px);
        transform: translateX(-50%);
      }
      #hn-root .hn-full-carousel__dot {
        width: 7px;
        height: 7px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: rgba(255,255,255,.55);
        cursor: pointer;
        transition: width .22s ease, border-radius .22s ease, background .22s ease;
      }
      #hn-root .hn-full-carousel__dot.is-active {
        width: 24px;
        border-radius: 99px;
        background: #ff9f1a;
      }
      @media (max-width: 1180px) {
        #hn-root .hn-banner-grid.hn-full-carousel { height: 560px; }
        #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__title {
          max-width: 520px;
          font-size: 43px;
        }
      }
      @media (max-width: 767px) {
        #hn-root .hn-banner-grid.hn-full-carousel {
          display: block !important;
          width: auto;
          height: min(128vw, 520px);
          min-height: 430px;
          max-height: 520px;
          margin: 12px 0 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
          border-radius: 16px;
        }
        #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner {
          min-height: 0;
          max-height: none;
          border-radius: 16px;
        }
        #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__content {
          left: 20px;
          right: 20px;
          bottom: 21px;
        }
        #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__title {
          max-width: 92%;
          font-size: clamp(30px, 9.2vw, 40px);
        }
        #hn-root .hn-banner-grid.hn-full-carousel .hn-vertical-banner__copy {
          max-width: 92%;
          font-size: 12px;
        }
        #hn-root .hn-full-carousel__arrow {
          width: 40px;
          height: 40px;
        }
        #hn-root .hn-full-carousel__arrow.prev { left: 11px; }
        #hn-root .hn-full-carousel__arrow.next { right: 11px; }
        #hn-root .hn-full-carousel__dots { top: 18px; }
      }
    `;
    document.head.appendChild(style);
  }

  function initFullCarousel() {
    addStyles();
    var carousel = document.querySelector('#hn-root .hn-banner-grid');
    if (!carousel || carousel.classList.contains('hn-full-carousel')) return;
    var slides = Array.from(carousel.querySelectorAll(':scope > .hn-vertical-banner'));
    if (slides.length < 2) return;

    carousel.classList.add('hn-full-carousel');
    var track = document.createElement('div');
    track.className = 'hn-full-carousel__track';
    slides.forEach(function (slide) { track.appendChild(slide); });
    carousel.appendChild(track);

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'hn-full-carousel__arrow prev';
    prev.setAttribute('aria-label', 'Previous banner');
    prev.innerHTML = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M15 18l-6-6 6-6"></path></svg>';

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'hn-full-carousel__arrow next';
    next.setAttribute('aria-label', 'Next banner');
    next.innerHTML = '<svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M9 18l6-6-6-6"></path></svg>';

    var dots = document.createElement('div');
    dots.className = 'hn-full-carousel__dots';
    dots.innerHTML = slides.map(function (_, index) {
      return '<button type="button" class="hn-full-carousel__dot' + (index === 0 ? ' is-active' : '') + '" aria-label="Show banner ' + (index + 1) + '"></button>';
    }).join('');

    carousel.appendChild(prev);
    carousel.appendChild(next);
    carousel.appendChild(dots);

    var index = 0;
    var timer = 0;
    var pointerStart = null;

    function show(newIndex) {
      index = (newIndex + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + (index * 100) + '%,0,0)';
      slides.forEach(function (slide, slideIndex) {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });
      dots.querySelectorAll('.hn-full-carousel__dot').forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, 6500);
    }

    prev.addEventListener('click', function () { show(index - 1); start(); });
    next.addEventListener('click', function () { show(index + 1); start(); });
    dots.addEventListener('click', function (event) {
      var list = Array.from(dots.children);
      var dotIndex = list.indexOf(event.target.closest('.hn-full-carousel__dot'));
      if (dotIndex >= 0) { show(dotIndex); start(); }
    });
    carousel.addEventListener('mouseenter', function () { clearInterval(timer); });
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('pointerdown', function (event) { pointerStart = event.clientX; });
    carousel.addEventListener('pointerup', function (event) {
      if (pointerStart == null) return;
      var distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 42) {
        show(index + (distance < 0 ? 1 : -1));
        start();
      }
    });
    carousel.addEventListener('pointercancel', function () { pointerStart = null; });

    show(0);
    start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFullCarousel);
  else initFullCarousel();
})();


/* HN_RESTORE_ORIGINAL_TWO_CARD_CAROUSEL_V3 */
(function () {
  var STYLE_ID = 'hn-restored-original-carousel-css';

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #hn-root .hn-hero-grid.hn-three-banner-layout {
        grid-template-columns: 280px minmax(0, 1fr) !important;
        align-items: stretch !important;
        gap: 16px !important;
      }
      #hn-root .hn-restored-slider {
        position: relative;
        width: 100%;
        min-width: 0;
        height: 620px;
        overflow: hidden;
        border-radius: 18px;
      }
      #hn-root .hn-restored-slider-track {
        display: flex;
        gap: 14px;
        height: 100%;
        transition: transform .6s cubic-bezier(.22,.75,.2,1);
        will-change: transform;
      }
      #hn-root .hn-restored-slide {
        position: relative;
        display: block;
        flex: 0 0 calc((100% - 14px) / 2);
        width: calc((100% - 14px) / 2);
        height: 100%;
        overflow: hidden;
        border: 1px solid rgba(8,64,78,.17);
        border-radius: 18px;
        background: #f3f6f6;
      }
      #hn-root .hn-restored-slide img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: transform .45s ease;
      }
      #hn-root .hn-restored-slide:hover img { transform: scale(1.018); }
      #hn-root .hn-restored-arr {
        position: absolute;
        top: 50%;
        z-index: 6;
        display: grid;
        place-items: center;
        width: 44px;
        height: 44px;
        padding: 0;
        border: 1px solid rgba(8,64,78,.1);
        border-radius: 50%;
        background: rgba(255,255,255,.96);
        color: #0b5162;
        box-shadow: 0 7px 19px rgba(0,0,0,.12);
        cursor: pointer;
        transform: translateY(-50%);
      }
      #hn-root .hn-restored-arr.prev { left: 16px; }
      #hn-root .hn-restored-arr.next { right: 16px; }
      #hn-root .hn-restored-dots {
        position: absolute;
        left: 50%;
        bottom: 16px;
        z-index: 6;
        display: flex;
        align-items: center;
        gap: 7px;
        padding: 7px 10px;
        border-radius: 999px;
        background: rgba(255,255,255,.88);
        box-shadow: 0 4px 14px rgba(0,0,0,.12);
        transform: translateX(-50%);
      }
      #hn-root .hn-restored-dot {
        width: 8px;
        height: 8px;
        padding: 0;
        border: 0;
        border-radius: 50%;
        background: #c6d0d3;
        cursor: pointer;
        transition: width .2s ease, background .2s ease;
      }
      #hn-root .hn-restored-dot.is-active {
        width: 25px;
        border-radius: 99px;
        background: #0d6677;
      }
      @media (max-width: 1180px) {
        #hn-root .hn-hero-grid.hn-three-banner-layout {
          grid-template-columns: 250px minmax(0, 1fr) !important;
        }
        #hn-root .hn-restored-slider { height: 560px; }
      }
      @media (max-width: 767px) {
        #hn-root .hn-hero-grid.hn-three-banner-layout { display: block !important; }
        #hn-root .hn-three-banner-layout > .hn-sidebar { display: none !important; }
        #hn-root .hn-restored-slider {
          height: min(132vw, 520px);
          min-height: 430px;
          margin-top: 12px;
          border-radius: 16px;
        }
        #hn-root .hn-restored-slider-track { gap: 0; }
        #hn-root .hn-restored-slide {
          flex-basis: 100%;
          width: 100%;
          border-radius: 16px;
        }
        #hn-root .hn-restored-arr {
          width: 40px;
          height: 40px;
        }
        #hn-root .hn-restored-arr.prev { left: 10px; }
        #hn-root .hn-restored-arr.next { right: 10px; }
        #hn-root .hn-restored-dots { bottom: 13px; }
      }
    `;
    document.head.appendChild(style);
  }

  function initRestoredCarousel() {
    addStyles();
    var grid = document.querySelector('#hn-root .hn-hero-grid');
    if (!grid || grid.querySelector('.hn-restored-slider')) return;
    grid.classList.add('hn-three-banner-layout');

    var generated = grid.querySelector('.hn-banner-grid');
    if (generated) generated.remove();
    var promo = grid.querySelector('.hn-promo-stack');
    if (promo) promo.remove();
    var original = grid.querySelector('.hn-slider');
    if (original) {
      var wrapper = original.parentElement;
      if (wrapper && wrapper !== grid) wrapper.remove();
      else original.remove();
    }

    var slides = [
      {
        href: '/collections/metal-awnings',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/da60b6ce-5216-4d72-a699-805c784ce344.png?v=1768402252',
        alt: 'Metal Awnings'
      },
      {
        href: '/collections/exterior-door',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/61450feb-f38f-472e-b9bb-a345b47679ba.png?v=1768402428',
        alt: 'Exterior Doors'
      },
      {
        href: '/pages/outdoor-structures',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/d9016405-22fd-4aff-a034-68625bc34eeb.png?v=1768402724',
        alt: 'Outdoor Structures'
      },
      {
        href: '/collections/interior-doors',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/059f2cf0-1f20-4378-9954-3e994b1c74dd.png?v=1768402648',
        alt: 'Interior Doors'
      },
      {
        href: 'https://share.google/TPTyZPRH9IWt92Gds',
        image: 'https://cdn.shopify.com/s/files/1/0615/8237/7015/files/48a90f82-3aa5-4b87-8f5f-a475a7630924.png?v=1768402049',
        alt: 'Visit our showroom'
      }
    ];

    var slider = document.createElement('div');
    slider.className = 'hn-slider hn-restored-slider';
    slider.setAttribute('aria-label', 'Featured categories');
    slider.innerHTML =
      '<div class="hn-restored-slider-track">' +
        slides.map(function (slide) {
          return '<a class="hn-slide hn-restored-slide" href="' + slide.href + '">' +
            '<img src="' + slide.image + '" alt="' + slide.alt + '" loading="lazy">' +
          '</a>';
        }).join('') +
      '</div>' +
      '<button type="button" class="hn-slider-arr hn-restored-arr prev" aria-label="Previous"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M15 18l-6-6 6-6"></path></svg></button>' +
      '<button type="button" class="hn-slider-arr hn-restored-arr next" aria-label="Next"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M9 18l6-6-6-6"></path></svg></button>' +
      '<div class="hn-restored-dots"></div>';

    grid.appendChild(slider);

    var track = slider.querySelector('.hn-restored-slider-track');
    var prev = slider.querySelector('.hn-restored-arr.prev');
    var next = slider.querySelector('.hn-restored-arr.next');
    var dots = slider.querySelector('.hn-restored-dots');
    var index = 0;
    var timer = 0;
    var pointerStart = null;

    function visibleCount() { return window.matchMedia('(max-width: 767px)').matches ? 1 : 2; }
    function maxIndex() { return Math.max(0, slides.length - visibleCount()); }
    function makeDots() {
      var count = maxIndex() + 1;
      dots.innerHTML = Array.from({ length: count }).map(function (_, i) {
        return '<button type="button" class="hn-restored-dot' + (i === index ? ' is-active' : '') + '" aria-label="Show banners ' + (i + 1) + '"></button>';
      }).join('');
    }
    function show(nextIndex) {
      var max = maxIndex();
      index = nextIndex < 0 ? max : nextIndex > max ? 0 : nextIndex;
      var firstCard = track.querySelector('.hn-restored-slide');
      var gap = visibleCount() === 1 ? 0 : 14;
      var step = firstCard ? firstCard.getBoundingClientRect().width + gap : slider.clientWidth;
      track.style.transform = 'translate3d(-' + (index * step) + 'px,0,0)';
      Array.from(dots.children).forEach(function (dot, dotIndex) {
        dot.classList.toggle('is-active', dotIndex === index);
      });
    }
    function start() {
      clearInterval(timer);
      timer = setInterval(function () { show(index + 1); }, 6200);
    }

    makeDots();
    show(0);
    prev.addEventListener('click', function () { show(index - 1); start(); });
    next.addEventListener('click', function () { show(index + 1); start(); });
    dots.addEventListener('click', function (event) {
      var dotIndex = Array.from(dots.children).indexOf(event.target.closest('.hn-restored-dot'));
      if (dotIndex >= 0) { show(dotIndex); start(); }
    });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', start);
    slider.addEventListener('pointerdown', function (event) { pointerStart = event.clientX; });
    slider.addEventListener('pointerup', function (event) {
      if (pointerStart == null) return;
      var distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 42) {
        show(index + (distance < 0 ? 1 : -1));
        start();
      }
    });
    window.addEventListener('resize', function () {
      index = Math.min(index, maxIndex());
      makeDots();
      show(index);
    });
    start();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRestoredCarousel);
  else initRestoredCarousel();
})();

/* HN_SHOW_RESTORED_CAROUSEL_V4 */
(function(){if(document.getElementById('hn-show-restored-carousel-css'))return;var s=document.createElement('style');s.id='hn-show-restored-carousel-css';s.textContent='#hn-root .hn-hero-grid.hn-three-banner-layout > .hn-restored-slider{display:block!important;}';document.head.appendChild(s);})();

/* HN_ORIGINAL_CAROUSEL_RATIO_V5 */
(function(){if(document.getElementById('hn-original-carousel-ratio-v5'))return;var s=document.createElement('style');s.id='hn-original-carousel-ratio-v5';s.textContent='#hn-root .hn-restored-slider{height:auto!important;aspect-ratio:1.37/1!important;}#hn-root .hn-restored-slide img{object-fit:cover!important;}@media(max-width:767px){#hn-root .hn-restored-slider{aspect-ratio:2/3!important;}}';document.head.appendChild(s);})();

/* HN_SALE_CATEGORY_V6 */
(function(){if(document.getElementById('hn-sale-category-css'))return;var s=document.createElement('style');s.id='hn-sale-category-css';s.textContent='#hn-cats .hn-sale-category{margin-top:8px;border:1px solid rgba(216,75,55,.28)!important;border-bottom:2px solid #d84b37!important;border-radius:12px!important;background:linear-gradient(90deg,#fff4ef,#fff);color:#b52f24;font-weight:800}.hn-sale-category .hn-sale-icon{width:38px;height:38px;display:grid;place-items:center;border-radius:50%;background:#d84b37;color:#fff;box-shadow:0 5px 14px rgba(216,75,55,.22)}.hn-sale-category .hn-sale-icon svg{width:20px;height:20px}.hn-mobile-sale{color:#b52f24!important;font-weight:800!important;background:#fff4ef!important;border-color:rgba(216,75,55,.25)!important}.hn-mobile-sale svg{color:#d84b37}';document.head.appendChild(s);var icon='<svg viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 13l-7 7-9-9V4h7z\"></path><circle cx=\"8.5\" cy=\"8.5\" r=\"1.5\"></circle></svg>';function add(){var c=document.getElementById('hn-cats');if(c&&!c.querySelector('.hn-sale-category'))c.insertAdjacentHTML('beforeend','<a class=\"hn-cat-row hn-sale-category\" href=\"/collections/sale\"><span class=\"hn-cat-ic\"><span class=\"hn-sale-icon\">'+icon+'</span><span>SALE</span></span><span aria-hidden=\"true\">›</span></a>');var m=document.getElementById('hn-mobile-cats');if(m&&!m.querySelector('.hn-mobile-sale'))m.insertAdjacentHTML('beforeend','<a class=\"hn-mobile-cat hn-mobile-sale\" href=\"/collections/sale\">'+icon+'<span>SALE</span></a>');return c&&c.querySelector('.hn-sale-category')}if(!add()){var n=0,t=setInterval(function(){if(add()||++n>40)clearInterval(t)},200)}})();


/* HN_MOBILE_TWO_BANNERS_V7 */
(function () {
  if (document.getElementById('hn-mobile-two-banners-v7')) return;
  var style = document.createElement('style');
  style.id = 'hn-mobile-two-banners-v7';
  style.textContent = `
    @media (max-width: 767px) {
      #hn-root .hn-restored-slider {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        aspect-ratio: 1.05 / 1 !important;
        border-radius: 14px !important;
      }
      #hn-root .hn-restored-slider-track {
        gap: 8px !important;
      }
      #hn-root .hn-restored-slide {
        flex: 0 0 calc((100% - 8px) / 2) !important;
        width: calc((100% - 8px) / 2) !important;
        min-width: calc((100% - 8px) / 2) !important;
        border-radius: 14px !important;
      }
      #hn-root .hn-restored-arr {
        width: 36px !important;
        height: 36px !important;
      }
      #hn-root .hn-restored-arr.prev { left: 7px !important; }
      #hn-root .hn-restored-arr.next { right: 7px !important; }
      #hn-root .hn-restored-dots {
        bottom: 9px !important;
        padding: 5px 8px !important;
      }
    }
  `;
  document.head.appendChild(style);
})();


/* HN_MOBILE_BANNER_RATIO_4X5_V8 */
(function () {
  if (document.getElementById('hn-mobile-banner-ratio-4x5-v8')) return;
  var style = document.createElement('style');
  style.id = 'hn-mobile-banner-ratio-4x5-v8';
  style.textContent = `
    @media (max-width: 767px) {
      #hn-root .hn-restored-slider {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        aspect-ratio: 1.6 / 1 !important;
      }
      #hn-root .hn-restored-slide {
        aspect-ratio: 4 / 5 !important;
        height: 100% !important;
      }
      #hn-root .hn-restored-slide img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        object-position: center center !important;
        background: #f3f6f6 !important;
      }
    }
  `;
  document.head.appendChild(style);
})();


/* HN_MOBILE_BANNER_EXACT_2X3_V9 */
(function () {
  if (document.getElementById('hn-mobile-banner-exact-2x3-v9')) return;
  var style = document.createElement('style');
  style.id = 'hn-mobile-banner-exact-2x3-v9';
  style.textContent = `
    @media (max-width: 767px) {
      #hn-root .hn-restored-slider {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        aspect-ratio: 1.36 / 1 !important;
      }
      #hn-root .hn-restored-slider-track {
        height: 100% !important;
        align-items: stretch !important;
      }
      #hn-root .hn-restored-slide {
        flex: 0 0 calc((100% - 8px) / 2) !important;
        width: calc((100% - 8px) / 2) !important;
        min-width: calc((100% - 8px) / 2) !important;
        height: 100% !important;
        aspect-ratio: 2 / 3 !important;
      }
      #hn-root .hn-restored-slide img {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
        object-position: center center !important;
      }
    }
  `;
  document.head.appendChild(style);
})();
